import React from "react";
import { useTranslation } from "react-i18next";
import Button from "components/bootstrap/Button";
import { Icon } from "components/common";
import useHasUndeclaredParameters from "views/logic/parameters/useHasUndeclaredParameters";
import useHotkey from "hooks/useHotkey";
const SaveAsDashboardButton = ({ onClick, openSaveAsModal }) => {
  const { t } = useTranslation("search");
  const hasUndeclaredParameters = useHasUndeclaredParameters();
  useHotkey({
    actionKey: "save-as",
    callback: () => openSaveAsModal(),
    scope: "dashboard",
    options: { enabled: !hasUndeclaredParameters }
  });
  return /* @__PURE__ */ React.createElement(Button, { onClick, disabled: hasUndeclaredParameters, title: t("save_view.save_as_new_dashboard_title") }, /* @__PURE__ */ React.createElement(Icon, { name: "content_copy" }), " ", t("save_view.save_as"));
};
export default SaveAsDashboardButton;
